import { DATATABLE_ALL } from './constants';
import { ajaxPromise, checkChosenChanged, confirmDialog, displayNotification, dtColumnIndicies, getDateFilter, getDtRowData, highlight, htmlEsc, initDateFilter, logerror, post, setDateFilter, toggleSlide } from './utils';

const initVendorIntake = () => {
	const intakeRouteSlug = $('#vendor_intake_manager_container').data('intake-route-slug') || 'vendor_intake';
	// Use the configured route slug (vendor_intake uses 'intake', outsource_planning uses 'planning')
	const routePath = intakeRouteSlug === 'outsource_planning' ? 'planning' : 'intake';

	const initFilters = () => {
		$('#vendor_intake_filter_container select.chosen').chosen({ width: '100%' });
		checkFiltersChosenChanged();
		$('#vendor_intake_filter_container select.chosen').on('change', ({ target }) => {
			const $select = $(target);
			checkChosenChanged($select);
		});
		toggleSlide($('#vendor_intake_filter_toggle'), $('#vendor_intake_filter_container'));

		initDateFilter('#vendor_intake_filter_date_submitted');
		initDateFilter('#vendor_intake_filter_date_reviewed');

		$('#vendor_intake_filter_container select, #vendor_intake_filter_container input[type="date"]').on('change', () => intakeDt.ajax.reload());

		const defaultFilters = getFilters();
		$('#vendor_intake_filter_reset').off('click').on('click', () => {
			setFilters(defaultFilters);
			checkFiltersChosenChanged();
			intakeDt.ajax.reload();
		});
	};

	const getFilters = () => ({
		submitter: $('#vendor_intake_filter_submitter').val(),
		status: $('#vendor_intake_filter_status').val(),
		recipient: $('#vendor_intake_filter_recipient').val(),
		reviewed_by: $('#vendor_intake_filter_reviewed_by').val(),
		date_submitted: getDateFilter('#vendor_intake_filter_date_submitted'),
		date_reviewed: getDateFilter('#vendor_intake_filter_date_reviewed'),
	});

	const setFilters = (filters) => {
		$('#vendor_intake_filter_submitter').val(filters.submitter);
		$('#vendor_intake_filter_status').val(filters.status);
		$('#vendor_intake_filter_sender').val(filters.sender);
		$('#vendor_intake_filter_recipient').val(filters.recipient);
		$('#vendor_intake_filter_reviewed_by').val(filters.reviewed_by);
		setDateFilter('#vendor_intake_filter_date_submitted', filters.date_submitted);
		$('#vendor_intake_filter_container select.chosen').trigger('chosen:updated');
		setDateFilter('#vendor_intake_filter_date_reviewed', filters.date_reviewed);
		$('#vendor_intake_filter_container select.chosen').trigger('chosen:updated');
	};

	const checkFiltersChosenChanged = () => $('#vendor_intake_filter_container select.chosen').each((_, element) => checkChosenChanged($(element)));

	const initIntakeTable = () => {
		const dbColumns: DataTables.ColumnSettings[] = [
			{ title: 'Vendor', data: 'vend_name', render: (val) => val === null ? '<i>N/A</i>' : htmlEsc(val) },
			{ title: 'Submitter', data: 'submitter' },
			{ title: 'Date Submitted', data: 'submit_date_pretty', searchable: false },
			{ title: 'Recipients', data: 'recipients' },
			{ title: 'Date Reviewed', data: 'review_date_pretty', searchable: false },
			{ title: 'Reviewed By', data: 'reviewed_by' },
			{ title: 'Status', data: 'intake_link_status_nice' },
			{ title: 'Actions', data: 'actions', className: 'text-right', orderable: false, searchable: false, render: null },
		];
		const columnIndicies = dtColumnIndicies(dbColumns);
		const dtOptions: DataTables.Settings = {
			ajax: {
				url: '/data/vendor_intake_load',
				data: (postData) => ({
					...postData,
					filters: getFilters(),
				}),
			},
			buttons: [
				{
					text: '<i class="fa fa-plus me-2"></i> Add',
					className: 'ml-2 btn btn-sm btn-success',
					action: () => {
						window.location.href = `/ui/${routePath}`;
					},
				},
				{
					text: '<i class="fa fa-file-csv me-2"></i> Export',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const $btn = $(target);
						const filters = getFilters();
						$btn.prop('disabled', true);

						post('/export', {
							type: 'vendor_intake',
							data: JSON.stringify(filters),
						});

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
				{
					text: '<i class="fa fa-print me-2"></i> Print',
					className: 'ml-2 btn btn-sm btn-secondary',
					action: ({ target }) => {
						const $btn = $(target);
						const filters = getFilters();
						$btn.prop('disabled', true);

						const params = {
							...intakeDt.ajax.params(),
							filters,
						};

						post('/printout/vendor_intake', { params: JSON.stringify(params) }, '_blank');

						setTimeout(() => $btn.prop('disabled', false), 1000);
					},
				},
			],
			columns: dbColumns,
			columnDefs: [
				{ responsivePriority: 1, targets: [columnIndicies.vend_name, columnIndicies.submitter] },
				{ responsivePriority: 2, targets: columnIndicies.actions },
				{ targets: '_all', render: (val) => htmlEsc(val) },
			],
			order: [[columnIndicies.submit_date_pretty, 'desc']],
		};
		const intakeDt = $('#vendor_intake_table').DataTable(dtOptions);

		$('#vendor_intake_table').on('draw.dt', () => {
			const $tooltip = $('#vendor_intake_table').find('.header-tooltip');
			$tooltip.tooltip({ html: true });
			$tooltip.on('click', (event) => {
				event.stopPropagation();
			});
		});

		$('#vendor_intake_table').on('click', '.vendor_intake_view', ({ target }) => {
			const row = getDtRowData(intakeDt, target);
			const hash = row.intake_link_hash
			post(`/ui/${routePath}/${hash}`, { surveyresp_guid: row.surveyresp_guid });
		});

		$('#vendor_intake_table').on('click', '.vendor_intake_delete', async ({ target }) => {
			const $btn = $(target);
			const intakeLinkId = $btn.data('intake-link-id');
			
			if (!intakeLinkId) {
				displayNotification('Delete Error', 'Unable to identify the form to delete.', 'danger');
				return;
			}

			const intakeLabel = $('#vendor_intake_manager_container').data('intake-label') || 'Vendor Intake';
			const confirmed = await confirmDialog({
				dialogTitle: `Delete ${intakeLabel} Form`,
				bodyText: `Are you sure you want to delete this ${intakeLabel.toLowerCase()} form?`,
				confirmText: 'Delete',
				confirmStyle: 'danger',
			});

			if (!confirmed) return;

			$btn.prop('disabled', true);
			try {
				const res = await ajaxPromise('/form/submit', {
					type: 'intake_link_delete',
					data: intakeLinkId,
				});

				if (res.rc !== 'OK') {
					throw res;
				}

				displayNotification(intakeLabel, 'Form deleted successfully.', 'success');
				intakeDt.ajax.reload();
			} catch (error) {
				displayNotification('Delete Error', 'Failed to delete form. Please try again.', 'danger');
				logerror('vendor intake delete error', error);
			} finally {
				$btn.prop('disabled', false);
			}
		});

		return intakeDt;
	};

	const intakeDt = initIntakeTable();
	initFilters();
};

if ($('#vendor_intake_manager_container').length == 1) initVendorIntake();

//On print window
if ($('#vendor_intake_printout').length == 1) {
	const deployPrintOut = async () => {
		const intakeLabel = $('#vendor_intake_printout').data('intake-label') || 'Vendor Intake';
		const params = JSON.parse(atob($('#vendor_intake_printout').data('params')));
		try {
			params.mode = DATATABLE_ALL;
			const res = await ajaxPromise('/data/vendor_intake_load', params);
			$('#spinner').show();

			const table = (
				<table className="table table-condensed table-striped" style="width: 100%;">
					<thead>
						<tr>
							{res.headers.map((col) => (
								<th>{col}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{res.data.map((row, index) => (
							<tr className={index % 2 == 0 ? 'odd' : 'even'} style="border-bottom: 1px solid #d0d0d0;">
								{row.map((cell) => (
									<td>{cell != null ? cell : ''}</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			);
			$('#vendor_intake_printout').append(table);
			$('#vendor_intake_printout_total').html(`${res.recordsFiltered} records`);

			setTimeout(() => {
				$('#spinner').hide();
				window.print();
			}, 1000);
		}
		catch (error) {
			displayNotification(intakeLabel, 'There was an error loading the data.', 'danger');
			logerror('vendor intake get error [ajax]', error);

		}
	};

	deployPrintOut();
}
